import styled from "styled-components";
import Image from "next/image";

export const MainImage = styled(Image)`
  width: 100%;
  height: 253px;
`;

export const Root = styled.div`
  display: flex;
  flex-direction: row;
  gap: 32px;
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 0em;

  @media (max-width: 1280px) {
    & {
      gap: 16px;
    }
  }

  @media (max-width: 1180px) {
    flex-direction: column-reverse;
  }

  @media (max-width: 579px) {
    font-size: 12px;
    line-height: 18px;
  }
`;

export const SlotBody = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 864px;
  gap: 48px;

  @media (max-width: 579px) {
    gap: 24px;
  }
`;

export const SlotHeaderImage = styled.div`
  flex: 1;
`;
export const SlotHeader = styled.div`
  display: flex;
  flex-direction: row;
  gap: 32px;

  @media (max-width: 1280px) {
    & {
      gap: 16px;
    }
  }

  @media (max-width: 1180px) {
    & ${SlotHeaderImage} {
      display: none;
    }
  }

  @media (max-width: 640px) {
    & {
      flex-direction: column;
    }
  }
`;

export const SlotHeaderData = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;
  padding-bottom: 4px;
  gap: 12px;

  @media (max-width: 640px) {
    & {
      padding: 0 2px;
    }
  }
`;

export const SlotHeaderH1 = styled.h1`
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: 0em;
  color: #e2f1ff;
  text-transform: uppercase;

  @media (max-width: 639px) {
    & {
      margin: auto;
      font-size: 18px;
      line-height: 24px;
    }
  }
`;

export const ProviderBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const ProviderName = styled.p`
  color: #e2f1ff;
  text-transform: uppercase;
`;

export const LabelBlock = styled.div`
  color: #e9f4ff80;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const LabelValue = styled.div`
  background: #1d2234;
  border: 2px solid #131620;
  box-shadow: 0px 0px 0px 2px #1d2234;
  border-radius: 4px;
  width: 100%;
  height: 52px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

export const SubLabel = styled.span`
  text-transform: uppercase;
  font-weight: 500;
  display: block;

  @media (max-width: 639px) {
    & {
      font-size: 12px;
    }
  }
`;

export const SlotMetaWrapper = styled.div`
  width: 300px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (max-width: 1180px) {
    width: 100%;
    padding: 0 2px;
  }
`;

export const SlotMeta = styled.div`
  background: #1d2234;
  width: 100%;
  border-radius: 4px;
  border: 2px solid #131620;
  box-shadow: 0px 0px 0px 2px #1d2234;
`;

export const SlotMetaIcon = styled(Image)`
  width: 16px;
  height: 16px;
  margin-right: 4px;
`;

export const SlotMetaHeader = styled.h4`
  font-weight: 600;
  color: #e2f1ff;
  text-transform: uppercase;
  padding: 16px;
  margin: 0;
  border-bottom: 1px solid #e9f4ff0d;
`;

export const SlotMetaMain = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 18px;

  @media (max-width: 1180px) {
    flex-direction: row;
    flex-wrap: wrap;
  }
`;

export const SlotMetaItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 12px;
`;

export const SlotMetaKey = styled.div`
  font-weight: 600;
  color: #e2f1ff;
  text-transform: uppercase;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const SlotMetaValue = styled.div`
  font-weight: 500;
  color: #3b8be9;
  text-transform: uppercase;
  text-wrap: nowrap;
`;

export const SlotMain = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;

  color: #e9f4ffbf;

  @media (max-width: 639px) {
    & {
      gap: 24px;
    }
  }

  & ul {
    @media (max-width: 579px) {
      & {
        padding-left: 12px;
      }
    }
  }

  & a {
    color: #23a3ff;
    text-decoration: underline;
  }

  & table {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid #e2f1ff;
    col {
      display: none;
    }
    tr,
    td {
      border: 1px solid #e2f1ff;
      padding: 1rem;
      @media (max-width: 768px) {
        & {
          padding: 0rem;
        }
      }
    }
    @media (max-width: 639px) {
      & {
        overflow: auto;
      }
    }
  }

  & .pros-cons {
    display: flex;
    flex-direction: row;
    gap: 16px;
    width: 100%;

    & h4 {
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
      letter-spacing: 0em;
      text-transform: uppercase;
      margin: 0;
    }

    & ul {
      display: flex;
      flex-direction: column;
      gap: 16px;
      margin: 0;
      @media (max-width: 579px) {
        & {
          padding-left: 12px;
          gap: 8px;
        }
      }
      & li {
        font-size: 14px;
        font-weight: 400;
        line-height: 21px;
        letter-spacing: 0em;
      }
    }

    & > div {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 24px;
      padding: 24px;
      border-radius: 4px;
    }

    & .pros {
      background: #5ebd3d06;
      border: 2px solid #131620;
      box-shadow: 0px 0px 0px 2px #5ebd3d06;

      & h4 {
        color: #5ebd3d;
      }
    }

    & .cons {
      background: #c842300d;
      border: 2px solid #131620;
      box-shadow: 0px 0px 0px 2px #c842300d;

      & h4 {
        color: #c84230;
      }
    }

    @media (max-width: 579px) {
      & {
        flex-direction: column;
      }
    }
  }

  & iframe,
  & img {
    border-radius: 4px;
    border: 1px solid #e9f4ff40;
    width: 100%;
    height: 470px;

    @media (max-width: 768px) {
      & {
        height: 354px;
      }
    }

    @media (max-width: 639px) {
      & {
        height: 284px;
      }
    }

    @media (max-width: 579px) {
      & {
        height: 242px;
      }
    }

    @media (max-width: 469px) {
      & {
        height: 212px;
      }
    }

    @media (max-width: 359px) {
      & {
        height: 164px;
      }
    }
  }
`;

export const TopImage = styled(Image)`
  @media (min-width: 1180px) {
    display: none;
  }

  width: 100%;
  height: auto;
  border-radius: 4px;
`;
